/**
 * @flow
 */

import React from 'react';
import { find, map } from 'lodash';
import Fuse from 'fuse.js';
import ServiceSelect from '../../components/form/ServiceSelect';

// Thin wrapper around ServiceSelect that:
// 1. Converts services array to dropdown options
// 2. Intercepts onChange to auto-set duration when a service is picked
// 3. Provides fuzzy search via Fuse.js
//
// Props expected from parent (Controller render prop):
//   value, onChange  — from RHF Controller
//   services         — array of service objects with { id, name, price, duration }
//   field            — field path prefix (e.g. "services.0")
//   change           — (name, val) => void — typically RHF setValue
export default function ServiceSelectContainer({
    services,
    onChange: onChangeProp,
    field,
    change,
    ...rest
}) {
    const options = map(services, ({ id, name, price, duration }) => ({
        value: id,
        text: name,
        description: price,
        'data-duration': `${duration} min`,
    }));

    const onChange = (e, { value }) => {
        const service = find(services, { id: value });
        if (service) {
            change(field ? `${field}.duration` : 'duration', service.duration);
        }
        onChangeProp(value);
    };

    const onSearch = (items, value) => {
        const fuse = new Fuse(items, {
            keys: ['text'],
            shouldSort: true,
            threshold: 0.3,
        });
        return fuse.search(value);
    };

    return (
        <ServiceSelect
            onChange={onChange}
            onSearch={onSearch}
            options={options}
            {...rest}
        />
    );
}
